/**
 * NewSimpleListItemInput — TextField inline single-line per "+ Aggiungi"
 * sotto le liste polimorfiche (EmailListEditor, PhoneListEditor).
 *
 * UX "add on confirm": Enter o blur invocano `onConfirm(value)`. Il
 * consumer decide se trim+empty significa cancel (vedi `useSimpleListItemEditor`
 * che chiude `isAdding` su valore vuoto). Esc invoca `onCancel` esplicito.
 *
 * Address NON usa questo input: ha NewAddressForm multi-field locale.
 */

import { useEffect, useRef, useState } from 'react';
import TextField from '@mui/material/TextField';

interface NewSimpleListItemInputProps {
  onConfirm: (value: string) => void | Promise<void>;
  onCancel: () => void;
  placeholder?: string;
}

export function NewSimpleListItemInput({ onConfirm, onCancel, placeholder }: NewSimpleListItemInputProps) {
  const [value, setValue] = useState('');
  const inputRef = useRef<HTMLInputElement | null>(null);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  return (
    <TextField
      inputRef={inputRef}
      value={value}
      onChange={(e) => setValue(e.target.value)}
      onBlur={() => void onConfirm(value)}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          void onConfirm(value);
        } else if (e.key === 'Escape') {
          e.preventDefault();
          onCancel();
        }
      }}
      size="small"
      fullWidth
      placeholder={placeholder}
      className="mt-xs"
    />
  );
}
